import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import Status from '../Status';
import Timestamp from '../Timestamp';

import styles from './index.module.css';

const MobileColumn2 = ({ value }) => {
  const status = value.get('status');
  const createdAt = value.get('createdAt');

  return (
    <div className={styles.root}>
      <Status value={status} />
      <div className={styles.bottom}>
        <Timestamp value={createdAt} textColor="rebranding-md-color-grey-60" />
      </div>
    </div>
  );
};

MobileColumn2.propTypes = {
  value: PropTypes.instanceOf(Map).isRequired,
};

export default MobileColumn2;
